import React, { Component } from 'react';

import Calculator from '../../components/Calculator';
import Disclaimer from '../../components/Disclaimer';

import RemainderAnnuityTrustInput from './RemainderAnnuityTrustInput';
import RemainderAnnuityTrustParams from './RemainderAnnuityTrustParams';
import RemainderAnnuityTrustPrint from './RemainderAnnuityTrustPrint';
import RemainderAnnuityTrustResult from './RemainderAnnuityTrustResult';
import { CRTContext } from '../../App.js'

import './RemainderAnnuityTrustPage.css';

import API from '../../api';

export default class RemainderAnnuityTrustPage extends Component {

  state = {
    trustType: this.props.initialParams !== null && this.props.initialParams.trustType === 'variable' ? 'variable' : 'fixed',
  }

  componentDidMount = () => {
    document.title = 'Charitable Remainder Trust - Gift Illustrator';
  }
  
  render() {
    var clientDefaults = this.props.clientDefaults;
    var initParams = this.props.initialParams;
    
    if (initParams !== null) {
      initParams.type = (initParams.age1 === null && initParams.age2 === null) || initParams.type === 'fixed' ? 'fixed' : (initParams.age1 !== null && initParams.age2 === null) || initParams.type === 'single' ? 'single' : 'double';
      initParams.method = initParams.method === null || initParams.method !== 'exact' ? 'interpolate' : 'exact';
      initParams.paymentSchedule = initParams.paymentschedule !== null ? initParams.paymentschedule : initParams.paymentSchedule !== null ? initParams.paymentSchedule : 'quarterly';
    }

    var pageName = 'Charitable Remainder Trust';
  
    var calculator = null;
    if (clientDefaults) {
      calculator = (
        <CRTContext.Consumer>
        { page =>
            <Calculator
                title={ pageName }
                page={ page }
                initialParams={ initParams }
                inputType={ RemainderAnnuityTrustInput }
                paramsType={ RemainderAnnuityTrustParams }
                printType={ RemainderAnnuityTrustPrint }
                resultType={ RemainderAnnuityTrustResult }
                onUpdate={ (params) => {
                  this.setState({trustType: params.trustType});
                  this.setState({type: params.type});
                }}
                onCalculate={ (request) => {
                  return API.getShared().annuityTrust(request);
                }}
                clientDefaults={ clientDefaults } />
        }
        </CRTContext.Consumer>
        );
    }

    return (<div className='remainder-trust-page'>
      { calculator }

      <Disclaimer />
    </div>);

  }

}
